"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetModalDisclaimer = exports.useCloseModalDisclaimer = exports.useActiveModalDisclaimer = exports.useModalDisclaimer = exports.ModalDisclaimersService = exports.ModalDisclaimerContext = void 0;
const react_1 = __importDefault(require("react"));
exports.ModalDisclaimerContext = react_1.default.createContext([{ active: false }, undefined]);
function ModalDisclaimersService(props) {
    const stateHook = react_1.default.useState(props.disclaimerData);
    return (react_1.default.createElement(exports.ModalDisclaimerContext.Provider, { value: stateHook }, props.children));
}
exports.ModalDisclaimersService = ModalDisclaimersService;
/**
 * Get modal disclaimer context data
 */
function useModalDisclaimer() {
    const [reviewModel] = react_1.default.useContext(exports.ModalDisclaimerContext);
    return reviewModel;
}
exports.useModalDisclaimer = useModalDisclaimer;
/**
 * Active modal disclaimer with new active number
 */
function useActiveModalDisclaimer() {
    const [data, updateModel] = react_1.default.useContext(exports.ModalDisclaimerContext);
    return (activeNumber) => updateModel && updateModel(Object.assign(Object.assign({}, data), { activeNumber, active: true }));
}
exports.useActiveModalDisclaimer = useActiveModalDisclaimer;
/**
 * Close modal disclaimer method
 */
function useCloseModalDisclaimer() {
    const [data, updateModel] = react_1.default.useContext(exports.ModalDisclaimerContext);
    return () => updateModel && updateModel(Object.assign(Object.assign({}, data), { activeNumber: undefined, active: false }));
}
exports.useCloseModalDisclaimer = useCloseModalDisclaimer;
/**
 * Set ALL modal disclaimer data
 */
function useSetModalDisclaimer() {
    const updateModel = react_1.default.useContext(exports.ModalDisclaimerContext)[1];
    return updateModel;
}
exports.useSetModalDisclaimer = useSetModalDisclaimer;
